import { render } from "./CandleTemplate.vue?vue&type=template&id=349e124d&scoped=true&lang=html"
import script from "./CandleTemplate.vue?vue&type=script&lang=js"
export * from "./CandleTemplate.vue?vue&type=script&lang=js"

import "./CandleTemplate.vue?vue&type=style&index=0&id=349e124d&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349e124d"]])

export default __exports__